import { render } from "./deletedProspects.vue?vue&type=template&id=32fdfe86"
import script from "./deletedProspects.vue?vue&type=script&lang=js"
export * from "./deletedProspects.vue?vue&type=script&lang=js"

import "./deletedProspects.vue?vue&type=style&index=0&id=32fdfe86&lang=css"

import exportComponent from "C:\\Users\\Luis\\Documents\\Anfisbena\\Projects\\crm\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__